if (!customElements.get('collection-slider-component')) {
  customElements.define(
    'collection-slider-component',
    class CollectionSliderComponent extends HTMLElement {
      constructor() {
        super();
        document.addEventListener('DOMContentLoaded', function() {
            const container = document.querySelector('.collection_slider_section_container');
            let isMouseDown = false;
            let startX, scrollLeft;
          
            container.addEventListener('mousedown', function(e) {
              isMouseDown = true;
              startX = e.pageX - container.offsetLeft;
              scrollLeft = container.scrollLeft;
            });
          
            container.addEventListener('mouseup', function() {
              isMouseDown = false;
              
            });
          
            container.addEventListener('mouseleave', function() {
              isMouseDown = false;
              
            });
          
            container.addEventListener('mousemove', function(e) {
              if (!isMouseDown) return;
              e.preventDefault();
              const x = e.pageX - container.offsetLeft;
              const walk = (x - startX); // Distance moved
              container.scrollLeft = scrollLeft - walk; 
            });
          });
          
      }
    }
  );
}
